import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Help() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // URL 파라미터에서 mode와 id 가져오기
  const urlMode = searchParams.get('mode') || 'list';
  const urlId = searchParams.get('id');

  const [mode, setMode] = useState(urlMode); // 'list', 'detail', 'create'
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 1235;

  const [inquiryData, setInquiryData] = useState({
    title: '',
    type: '',
    content: '',
  });

  // 샘플 데이터
  const inquiries = [
    {
      id: 1,
      state: 'wait',
      stateText: '답변 대기',
      category: '내 논문 문의',
      title: '논문 저자 수정 부탁드립니다.',
      date: '2025-12-02',
      canEdit: true,
    },
    {
      id: 2,
      state: 'complete',
      stateText: '답변 완료',
      category: '내 아이디 문의',
      title: '1:1 문의 내용이 보여집니다. 길어질 경우 한 줄에서 말줄임이 됩니다. 1:1 문의 내용이 보여집니다. 길어질 경우 한 줄에서 말줄임이 됩니다.1:1 문의 내용이 보여집니다. 길어질 경우 한 줄에서 말줄임이 됩니다.1:1 문의 내용이 보여집니다. 길어질 경우 한 줄에서 말줄임이 됩니다.1:1 문의 내용이 보여집니다. 길어질 경우 한 줄에서 말줄임이 됩니다.',
      date: '2025-12-02',
      canEdit: false,
      question: '아래의 아이디를 생성하신 후 입력해 주세요. 아이디별 생성 사이트는 위의 바로가기를 참고하세요.<br>위 등록된 리스트에 해당 아이디가 있다면 생성하지 않아도 됩니다.<br>_____________________________________________<br>ORCID : 0000-0002-2896-3365<br>ResearchGate ID :<br>Scopus ID : 36068418900<br>Researcher ID(WoS) :<br>_____________________________________________<br>등록된 아이디 중 수정이 필요할 경우 아래에 적어 주세요.',
      questionImages: [
        { type: 'small', src: rmVars.themeUrl + 'images/altmetric01.png' },
        { type: 'large', src: rmVars.themeUrl + 'images/add_img01.png' },
      ],
      answer: '안녕하십니까? 부산대학교 도서관입니다.<br>작성해주신 ORCID를 등록하였습니다.<br>앞으로도 저희 PNU Scholar에 많은 관심 부탁드립니다. 감사합니다.<br>관련 문의: 051-510-1817(도서관 연구정보지원팀 송재학)',
      answerDate: '2025-11-22 08:58',
    },
    {
      id: 3,
      state: 'complete',
      stateText: '답변 완료',
      category: '기타 문의',
      title: 'JCR 2024 리스트 요청',
      date: '2025-12-02',
      canEdit: false,
    },
  ];

  // URL 파라미터 변경 시 mode와 selectedInquiry 업데이트
  useEffect(() => {
    const urlMode = searchParams.get('mode') || 'list';
    const urlId = searchParams.get('id');

    setMode(urlMode);

    if (urlId && urlMode === 'detail') {
      const inquiry = inquiries.find(inq => inq.id === parseInt(urlId));
      if (inquiry) {
        setSelectedInquiry(inquiry);
      } else {
        // ID가 있지만 해당 문의를 찾을 수 없으면 리스트로 이동
        setSearchParams({});
      }
    } else if (urlMode === 'list') {
      setSelectedInquiry(null);
    }
  }, [searchParams]);

  const handleInputChange = (field, value) => {
    setInquiryData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    setSearchParams({});
    setInquiryData({ title: '', type: '', content: '' });
  };

  const handleInquiryClick = (inquiry) => {
    setSelectedInquiry(inquiry);
    setSearchParams({ mode: 'detail', id: inquiry.id.toString() });
  };

  const handleCreateClick = () => {
    setSearchParams({ mode: 'create' });
  };

  const handleBackToList = () => {
    setSearchParams({});
    setSelectedInquiry(null);
  };
  const handleDelete = (id) => {
    // TODO: API 호출
    // console.log('Delete inquiry:', id);
  };

  const handleEdit = (id) => {
    // TODO: 편집 모드로 전환 또는 API 호출
    // console.log('Edit inquiry:', id);
  };

  // 리스트 뷰
  const renderListView = () => (
    <>
      <div className="flex justify-between items-center w-full">
        <h3 className="text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">Help & Support</h3>

        <div className="hidden lg:flex gap-2 items-center">
          <button
            onClick={handleCreateClick}
            className="btn-edit flex rounded-[12px] items-center justify-center gap-2 px-4 py-3 text-[14px] text-white font-semibold leading-[100%] bg-[#333]"
          >
            <img src={rmVars.themeUrl + 'images/contact-ico-wh.png'} className="w-[18px]" alt="edit" />
            <span>1:1 문의하기</span>
          </button>
        </div>
      </div>

      <div className="mt-[40px] lg:mt-6 lg:p-[60px] bg-white rounded-[12px]">
        <p className="mb-4 text-[18px] lg:text-[20px] font-bold">내가 보낸 1:1 문의</p>

        <div className="help-table">
          <table className="border-t border-t-[#E4E8F1] w-full">
            <thead className="hidden xl:table-header-group">
              <tr>
                <th className="state">State</th>
                <th className="cate">Category</th>
                <th className="tit">Title</th>
                <th className="date">Date</th>
                <th className="btns">Edit/Delete</th>
              </tr>
            </thead>

            <tbody>
              {inquiries.length > 0 ? (
                inquiries.map((inquiry) => (
                  <tr key={inquiry.id} className="cursor-pointer" onClick={() => handleInquiryClick(inquiry)}>
                    <td className={`state ${inquiry.state}`}>{inquiry.stateText}</td>
                    <td className="cate">
                      <span>{inquiry.category}</span>
                    </td>
                    <td className="tit">
                      <div className="truncate">{inquiry.title}</div>
                    </td>
                    <td className="date">{inquiry.date}</td>
                    <td className="btns" onClick={(e) => e.stopPropagation()}>
                      <div>
                        {inquiry.canEdit && (
                          <button
                            onClick={() => handleEdit(inquiry.id)}
                            className="edit"
                          >
                            Edit
                          </button>
                        )}
                        <button
                          onClick={() => handleDelete(inquiry.id)}
                          className="delete"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="noresult flex justify-center !h-auto !cursor-default !pl-0">
                  <td colSpan="5" className="w-full !py-[72px] lg:!py-[158px] text-center">
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 페이저 */}
        <div className="flex items-center justify-center gap-2 font-[Pretendard] text-[15px] mt-[50px] lg:mt-[40px]">
          <button
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="shrink-0 p-2 rounded-md cursor-pointer disabled:opacity-50"
            aria-label="prev"
          >
            <img src={rmVars.themeUrl + 'images/pager_prev.png'} alt="prev" className="w-4 h-4" />
          </button>

          <button
            onClick={() => setCurrentPage(1)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer ${currentPage === 1 ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            1
          </button>
          <button
            onClick={() => setCurrentPage(2)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer ${currentPage === 2 ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            2
          </button>
          <button
            onClick={() => setCurrentPage(3)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer ${currentPage === 3 ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            3
          </button>
          <button
            onClick={() => setCurrentPage(4)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer hidden lg:block ${currentPage === 4 ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            4
          </button>
          <button
            onClick={() => setCurrentPage(5)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer hidden lg:block ${currentPage === 5 ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            5
          </button>
          <span className="text-[#6C7687] select-none px-1">...</span>
          <button
            onClick={() => setCurrentPage(totalPages)}
            className={`px-[15px] py-2 rounded-md font-medium cursor-pointer ${currentPage === totalPages ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#E4E8F1]'}`}
          >
            {totalPages}
          </button>

          <button
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="shrink-0 p-2 rounded-md cursor-pointer disabled:opacity-50"
            aria-label="next"
          >
            <img src={rmVars.themeUrl + 'images/pager_next.png'} alt="next" className="w-4 h-4" />
          </button>
        </div>
      </div>
    </>
  );

  // 상세 뷰
  const renderDetailView = () => {
    if (!selectedInquiry) return null;

    return (
      <>
        <div className="flex justify-between items-center w-full">
          <h3 className="text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">Help & Support</h3>
        </div>

        <div className="mt-[40px] lg:mt-6 lg:p-[60px] bg-white rounded-[12px]">
          <p className="mb-4 text-[18px] lg:text-[20px] font-bold">내가 보낸 1:1 문의</p>

          <div className="help-table">
            <table className="border-t border-t-[#E4E8F1] w-full">
              <thead className="hidden xl:table-header-group">
                <tr>
                  <th className="state">State</th>
                  <th className="cate">Category</th>
                  <th className="tit">Title</th>
                  <th className="date">Date</th>
                  <th className="btns">Edit/Delete</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className={`state ${selectedInquiry.state}`}>{selectedInquiry.stateText}</td>
                  <td className="cate">
                    <span>{selectedInquiry.category}</span>
                  </td>
                  <td className="tit">
                    <div>{selectedInquiry.title}</div>
                  </td>
                  <td className="date">{selectedInquiry.date}</td>
                  <td className="btns">
                    <div>
                      <button
                        onClick={() => handleDelete(selectedInquiry.id)}
                        className="delete"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {selectedInquiry.question && (
            <div className="help-cont-wrap">
              {/* 질문 */}
              <div className="contact-cont-wrap contact-cont-q">
                <p className="tit">Q</p>
                <div className="contact-cont">
                  <div
                    className="txt-wrap"
                    dangerouslySetInnerHTML={{ __html: selectedInquiry.question }}
                  />

                  {selectedInquiry.questionImages?.map((img, idx) => (
                    <div key={idx} className={`img-wrap ${img.type}-img`}>
                      <img src={img.src} alt="img" />
                    </div>
                  ))}
                </div>
              </div>

              {/* 답변 */}
              {selectedInquiry.answer && (
                <div className="contact-cont-wrap contact-cont-q">
                  <p className="tit">A</p>
                  <div className="contact-cont">
                    <div
                      className="txt-wrap"
                      dangerouslySetInnerHTML={{ __html: selectedInquiry.answer }}
                    />
                    {selectedInquiry.answerDate && (
                      <div className="date">{selectedInquiry.answerDate}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  // 작성 뷰
  const renderCreateView = () => (
    <>
      <div className="flex justify-between items-center w-full">
        <h3 className="text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">Help & Support</h3>
      </div>

      <div className="mt-[40px] lg:mt-6 lg:p-[60px] bg-white rounded-[12px]">
        <p className="mb-3 text-[18px] lg:text-[20px] font-bold text-center">1:1 문의</p>

        <p className="text-[14px] text-center text-[#6C7687]">문의하실 내용을 보내주시면 담당자 확인 후 답변드립니다.</p>

        <div className="flex flex-col gap-[30px] lg:gap-6 md:max-w-[386px] mt-9 md:mx-auto">
          {/* 제목 */}
          <div className="flex flex-col gap-[10px] w-full">
            <span className="text-[14px] font-medium lg:text-[#6C7687]">제목</span>
            <div className="w-full">
              <input
                type="text"
                placeholder="문의 제목을 입력해 주세요."
                value={inquiryData.title}
                onChange={(e) => handleInputChange('title', e.target.value)}
                className="w-full h-[44px] px-4 border border-[#E4E8F1] rounded-[8px] text-[13px] placeholder-[#B4BCCC] outline-none bg-white"
              />
            </div>
          </div>

          {/* 문의유형 */}
          <div className="flex flex-col gap-[10px] w-full">
            <span className="text-[14px] font-medium lg:text-[#6C7687]">문의 유형 선택</span>
            <div className="w-full">
              <select
                value={inquiryData.type}
                onChange={(e) => handleInputChange('type', e.target.value)}
                className="w-full h-[44px] px-4 pr-[40px] border border-[#E4E8F1] rounded-[8px] text-[13px] placeholder-[#B4BCCC] outline-none appearance-none bg-white text-line-1 cursor-pointer"
                style={{
                  backgroundImage: `url(${rmVars.themeUrl}images/expand_more_6C7687.png)`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '16px',
                  backgroundPosition: 'calc(100% - 16px)',
                }}
              >
                <option value="" disabled hidden>문의 유형 선택</option>
                <option>option1option1option1option1option1</option>
                <option>option2</option>
                <option>option3</option>
                <option>option4</option>
                <option>option5</option>
              </select>
            </div>
          </div>

          {/* 문의 내용 */}
          <div className="flex flex-col gap-[10px] w-full">
            <span className="text-[14px] font-medium lg:text-[#6C7687]">내용</span>
            <div className="w-full">
              <textarea
                placeholder="문의 내용을 입력해 주세요."
                value={inquiryData.content}
                onChange={(e) => handleInputChange('content', e.target.value)}
                className="w-full h-[120px] lg:h-[280px] px-4 py-[14px] border border-[#E4E8F1] rounded-[8px] text-[13px] placeholder-[#B4BCCC] outline-none bg-white"
              />
            </div>
          </div>

          <div className="flex justify-center w-full">
            <button
              onClick={handleSubmit}
              className="w-full h-[42px] text-[14px] font-semibold text-white rounded-[12px] bg-[#333] cursor-pointer"
            >
              문의 보내기
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div>
      {mode === 'list' && renderListView()}
      {mode === 'detail' && renderDetailView()}
      {mode === 'create' && renderCreateView()}
    </div>
  );
}
